/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { paymentMethodSetNickname } from '../../axios/paymentMethodSetNickname'
import type {
	PaymentMethodSetNicknameError,
	PaymentMethodSetNicknamePathParams,
	PaymentMethodSetNicknameRequest,
	PaymentMethodSetNicknameResponse,
} from '../../types/PaymentMethodSetNickname'

export const paymentMethodSetNicknameMutationKey = () =>
	[{ url: '/:organisation/payment-methods/:paymentMethod/nickname' }] as const

export type PaymentMethodSetNicknameMutationKey = ReturnType<typeof paymentMethodSetNicknameMutationKey>

export type PaymentMethodSetNicknameVariables = {
	organisation: PaymentMethodSetNicknamePathParams['organisation']
	paymentMethod: PaymentMethodSetNicknamePathParams['paymentMethod']
	data: PaymentMethodSetNicknameRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::setNickname */
export function usePaymentMethodSetNickname<TContext = unknown>(
	options?: UseMutationOptions<
		PaymentMethodSetNicknameResponse,
		AxiosError<PaymentMethodSetNicknameError>,
		PaymentMethodSetNicknameVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: paymentMethodSetNicknameMutationKey(),
		mutationFn: ({ organisation, paymentMethod, data }: PaymentMethodSetNicknameVariables) =>
			paymentMethodSetNickname(organisation, paymentMethod, data, config).then(res => res.data),
		...options,
	})
}
